import BasicTab from '../components/BasicTab';
import MarkdownView from '../components/MarkdownView';
import {T} from '../core/Translate';
import {TabKey} from '../models/TabKeys';

export default function CompletedTab() {
  return (
    <BasicTab tab={TabKey.Completed}>
      <ol>
        <li>{T('confirmation.completed.step.contactForInstallation')}</li>
        <li>
          <MarkdownView content={T('confirmation.completed.step.support')} />
        </li>
      </ol>
    </BasicTab>
  );
}
